/* 28.10 (audyt wizualny, Marta: „zatwierdzam wszystko”): dymek czatu Shopify Inbox.
   Na telefonie (do 749 px) zamiast pigułki „Czat” okrągła ikona 48 px przy prawej krawędzi, żeby nie zasłaniała przycisków, cen i sumy w koszyku.
   Angielski dymek „Chat about these items” jest ukrywany. Czat siedzi w otwartym shadow DOM, więc styl wstawiamy do środka.
   Wczytywany w snippets/meta-tags.liquid. Powrót: usuń linijkę z pk-czat.js. */
(function () {
  var css = '@media (max-width:749px){' +
    '.activator-nudge{right:12px!important}' +
    '.activator{width:48px!important;height:48px!important;min-width:0!important;min-height:0!important;padding:0!important;border-radius:50%!important;justify-content:center!important;gap:0!important}' +
    '.activator__label{display:none!important}' +
    '}';
  function popraw() {
    var h = document.querySelector('shopify-chat'); if (!h || !h.shadowRoot) return false;
    var sr = h.shadowRoot;
    if (!sr.getElementById('pk-czat')) { var s = document.createElement('style'); s.id = 'pk-czat'; s.textContent = css; sr.appendChild(s); }
    sr.querySelectorAll('*').forEach(function (e) {
      if (e.children.length || !/chat about|these items/i.test(e.textContent || '')) return;
      var p = e.parentElement;
      if (p && !p.querySelector('.activator') && !p.closest('.activator')) p.style.display = 'none'; else e.style.display = 'none';
    });
    if (!sr.__pk && window.MutationObserver) { sr.__pk = 1; new MutationObserver(function () { popraw(); }).observe(sr, { childList: true, subtree: true, characterData: true }); }
    return true;
  }
  var n = 0, t = setInterval(function () { if (popraw() || ++n > 40) clearInterval(t); }, 500);
})();
/* 28.10 (Marta: „jako Velvet Soft zapisz”): przyciski filtra materiału na listach (sections/pk-lista-nugget.liquid)
   powiększają tylko pierwszą literę, więc pokazywały „Velvet soft”. Tu poprawiamy sam napis, filtr działa bez zmian. */
(function () {
  function napisy() {
    document.querySelectorAll('.pkg__tk button, .pkn__tk button').forEach(function (b) {
      if (b.textContent.trim().toLowerCase() === 'velvet soft' && b.textContent !== 'Velvet Soft') b.textContent = 'Velvet Soft';
    });
  }
  var n = 0, t = setInterval(function () { napisy(); if (++n > 20) clearInterval(t); }, 300);
})();
